import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Label } from 'components/core/Label';

export default function RadioGroup({
	name, label, error, value, children, onChange
}) {
	return (
		<Label
			text={label}
			htmlFor={name}
			className={classnames('ss-radio-group-label', { error })}
			render={() => (
				<Fragment>
					<div className="ss-radios">
						{React.Children.map(children, (child) => (
							React.cloneElement(child, {
								name: child.props.name || name,
								checked: value === child.props.value,
								onChange
							})
						))}
					</div>
					{!!error &&
						<div className="error-message">
							{error}
						</div>
					}
				</Fragment>
			)}
		/>
	);
}

RadioGroup.propTypes = {
	name: PropTypes.string,
	label: PropTypes.string,
	error: PropTypes.string,
	value: PropTypes.string,
	children: PropTypes.node,
	onChange: PropTypes.func
};
